export enum RouteStatus {
  SCHEDULED = 'scheduled',
  ACTIVE = 'active',
  DRAFT = 'draft'
}